import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export default function ChangePasswordModal({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("La nueva contraseña y su confirmación no coinciden");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada");
      setCurrent(""); setNext(""); setConfirm("");
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo cambiar la contraseña");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="change-password-modal">
        <DialogHeader><DialogTitle>Cambiar mi contraseña</DialogTitle></DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="vv-label">Contraseña actual *</Label>
            <Input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
              data-testid="current-password-input" autoComplete="current-password" />
          </div>
          <div>
            <Label className="vv-label">Nueva contraseña *</Label>
            <Input type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)}
              data-testid="new-password-input" autoComplete="new-password" />
            <p className="text-[11px] text-gray-500 mt-1">Mínimo 6 caracteres.</p>
          </div>
          <div>
            <Label className="vv-label">Repite la nueva contraseña *</Label>
            <Input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
              data-testid="confirm-password-input" autoComplete="new-password" />
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={onClose}>Cancelar</Button>
            <Button type="submit" disabled={saving} className="bg-blue-600 hover:bg-blue-700" data-testid="change-password-submit">
              {saving && <Loader2 size={14} className="mr-1 animate-spin" />} Guardar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
